import { atom } from 'jotai';
import { Article } from '../../types';
import { Loadable, LoadableState } from '../../utils';

export type ErsteMarketAnalysisState = LoadableState<Article[]>;

export type ErsteMarketAnalysisAtomState = {
  articles: ErsteMarketAnalysisState;
  hasMore: boolean;
  currentPage: number;
};

export const ersteMarketAnalysisAtom = atom<ErsteMarketAnalysisAtomState>({
  articles: Loadable.loading,
  hasMore: true,
  currentPage: 1,
});
